export default __webpack_public_path__ + "static/media/loader.ece48b52.gif";